import api from './api';
import { Projekt, ProjektCreate, ProjektList, FileEntity } from '../types';

export const projekteService = {
  list: async (params?: { status_id?: number; kunde_id?: number; projekt_typ?: string; mitarbeiter_id?: number }): Promise<ProjektList[]> => {
    const response = await api.get('/projekte/', { params });
    return response.data;
  },

  get: async (id: number): Promise<Projekt> => {
    const response = await api.get(`/projekte/${id}`);
    return response.data;
  },

  create: async (data: ProjektCreate): Promise<Projekt> => {
    const response = await api.post('/projekte/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<ProjektCreate>): Promise<Projekt> => {
    const response = await api.put(`/projekte/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/projekte/${id}`);
  },

  getFilesToDelete: async (id: number): Promise<FileEntity[]> => {
    const response = await api.get(`/projekte/${id}/files-to-delete`);
    return response.data;
  },
};
